// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FPOForm_textField__\\+uCJ- {
  margin: 15px 0px !important;
  font-family: "Montserrat" !important;
}
.FPOForm_titleHead__3jaJh {
  font-family: "Montserrat" !important;
  font-size: 32px !important;
  font-weight: 600 !important;
  line-height: 40px !important;
  color: #3d4a52 !important;
  margin: 30px 2px !important;
}
.FPOForm_selectBox__qTjyT {
  width: 100% !important;
  margin-top: 10px;
  margin-bottom: 10px;
  display: block;
}
.FPOForm_selectBox__qTjyT > p {
  margin-right: 20px;
  font-size: larger;
}
.FPOForm_saveBtn__QUbyq {
  font-family: "Montserrat" !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 26px !important;
  letter-spacing: 0px !important;
  text-align: left !important;
  width: 172px !important;
  height: 48px !important;
  padding: 11px, 55px, 11px, 56px !important;
  border-radius: 8px !important;
  background-color: #00ab55 !important;
  color: #ffffff !important;
  text-transform: capitalize !important;
  cursor: pointer !important;
  box-shadow: none !important;
}
.FPOForm_saveBtn__QUbyq:disabled {
  background-color: #79a280 !important;
  color: white !important;
  box-shadow: none !important;
  font-family: "Montserrat" !important;
}
.FPOForm_title__qLpB8 {
  font-weight: 700 !important;
  font-size: 34px !important;
}
.FPOForm_subTitle__VtEbv {
  font-family: "Montserrat" !important;
  font-size: 32px !important;
  font-weight: 600 !important;
  line-height: 40px !important;
  letter-spacing: 0px !important;
  text-align: left !important;
  margin-top: 50px !important;
  color: #3d4a52 !important;
}
.FPOForm_checkBox__Fu\\+iF {
  margin: 20px 0px !important;
}
.FPOForm_subTitleCertificates__bV5mK {
  font-family: "Montserrat" !important;
  font-size: 20px !important;
  font-weight: 600 !important;
  line-height: 24.38px !important;
  letter-spacing: 0px !important;
  text-align: left !important;
  margin-top: 20px !important;
  margin-left: 5px !important;
}
.FPOForm_margin5__ENqdI {
  margin: 10px 0px !important;
}
.FPOForm_fileText__LH1ME {
  font-family: "Montserrat" !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 20px !important;
  letter-spacing: 0px !important;
  text-align: left !important;
}
.FPOForm_blue__DOxKy {
  color: #3366ff;
  padding-left: 10px !important;
}
.FPOForm_document_upload_logo__-bqpj {
  flex: 0.1 1;
}
.FPOForm_each_preview_policy__fibe2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: auto;
  padding: 15px 0px !important;
  border-radius: 10px;
  font-family: "Montserrat" !important;
}
.FPOForm_link__DOeIe {
  max-width: 350px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  text-decoration: underline;
}
.FPOForm_link__DOeIe:hover {
  text-decoration: underline;
  cursor: pointer;
}
.FPOForm_text_left__oSnaI {
  text-align: left !important;
  font-family: "Montserrat" !important;
}
.FPOForm_fileTextSize__mDwvz {
  font-size: 18px !important;
  font-weight: 600 !important;
  line-height: 24.38px !important;
}
.FPOForm_certificateCountStyle__NUT-6{
  font-size: 18px !important;
  font-weight: 400 !important;
  font-family: "Montserrat" !important;
}
.FPOForm_addMoreBtn__sDRP9 {
  font-family: "Montserrat" !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  line-height: 24px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
  color: #00ab55 !important;
  text-transform: none !important;
}
.FPOForm_removeBtn__4upRn {
  color: #ff5630 !important;
  font-family: "Montserrat" !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  line-height: 24px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
  text-transform: capitalize !important;
}
.FPOForm_primaryButton__WIoM1 {
  font-family: "Montserrat" !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 26px !important;
  letter-spacing: 0px !important;
  text-align: left !important;
  width: 172px !important;
  height: 48px !important;
  padding: 11px, 55px, 11px, 56px !important;
  border-radius: 8px !important;
  border: 1px solid #00ab55 !important ;
  box-shadow: none !important;
  color: #00ab55 !important;
  background-color: none !important;
  text-transform: none !important;
  cursor: pointer !important;
}
.FPOForm_fileErrorMeesage__aqtkj {
  font-size: 14px !important;
  color: #ff5630 !important;
  font-family: "Montserrat" !important;
}
.FPOForm_note__0hjKd {
  font-family: "Montserrat" !important;
  width: 380px !important;
  text-align: center !important;
  margin-left: 90px !important;
  margin-top: 20px !important;
  font-size: 14px !important;
}
.FPOForm_noteGuarantee__UznLU {
  font-family: "Montserrat" !important;
  width: 385px !important;
  text-align: center !important;
  margin-left: 100px !important;
  margin-top: 20px !important;
  font-size: 14px !important;
}
.FPOForm_buttonStyle__ttKp- {
  max-width: -moz-fit-content !important;
  max-width: fit-content !important;
  margin-left: auto !important;
  margin-right: 25px !important;
}
.FPOForm_backButton__sn7Ow {
  font-family: "Montserrat" !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 26px !important;
  letter-spacing: 0px !important;
  width: 74px !important;
  height: 48px !important;
  padding: 11px, 0px, 11px, 0px !important;
  color: #00ab55 !important;
  text-transform: none !important;
  cursor: pointer !important;
  margin: 20px 0px 10px 0px !important;
}
.FPOForm_subHead__KNWW8 {
  font-family: "Montserrat" !important;
  font-size: 20px !important;
  font-weight: 600 !important;
  letter-spacing: 0px !important;
  text-align: left !important;
  margin-top: 30px !important;
  color: #000000 !important;
  line-height: 24.38px;
}
.FPOForm_lastUpdate__5mD3e {
  color: #212b36 !important;
  font-size: 14px !important;
  font-family: "Montserrat" !important;
  font-weight: 400 !important;
  margin-top: 40px !important;
  margin-bottom: 30px !important;
  height: 24px !important;
  line-height: 24px !important;
  margin-bottom: 5px;
}
.FPOForm_certificateName__A-x\\+s {
  font-family: "Montserrat" !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 30px !important;
  color: #000000 !important;
  max-height: 245px !important;
}
.FPOForm_fileSize__jTZSn {
  color: #7c7c7c !important;
  font-family: "Montserrat" !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 17.07px !important;
  text-decoration: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/FPOForm/FPOForm.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,0CAA0C;EAC1C,6BAA6B;EAC7B,oCAAoC;EACpC,yBAAyB;EACzB,qCAAqC;EACrC,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,2BAA2B;EAC3B,oCAAoC;AACtC;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,WAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,qCAAqC;AACvC;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,0CAA0C;EAC1C,6BAA6B;EAC7B,qCAAqC;EACrC,2BAA2B;EAC3B,yBAAyB;EACzB,iCAAiC;EACjC,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,sCAAiC;EAAjC,iCAAiC;EACjC,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,wCAAwC;EACxC,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,oCAAoC;EACpC,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,gCAAgC;AAClC","sourcesContent":[".textField {\n  margin: 15px 0px !important;\n  font-family: \"Montserrat\" !important;\n}\n.titleHead {\n  font-family: \"Montserrat\" !important;\n  font-size: 32px !important;\n  font-weight: 600 !important;\n  line-height: 40px !important;\n  color: #3d4a52 !important;\n  margin: 30px 2px !important;\n}\n.selectBox {\n  width: 100% !important;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  display: block;\n}\n.selectBox > p {\n  margin-right: 20px;\n  font-size: larger;\n}\n.saveBtn {\n  font-family: \"Montserrat\" !important;\n  font-size: 16px !important;\n  font-weight: 700 !important;\n  line-height: 26px !important;\n  letter-spacing: 0px !important;\n  text-align: left !important;\n  width: 172px !important;\n  height: 48px !important;\n  padding: 11px, 55px, 11px, 56px !important;\n  border-radius: 8px !important;\n  background-color: #00ab55 !important;\n  color: #ffffff !important;\n  text-transform: capitalize !important;\n  cursor: pointer !important;\n  box-shadow: none !important;\n}\n.saveBtn:disabled {\n  background-color: #79a280 !important;\n  color: white !important;\n  box-shadow: none !important;\n  font-family: \"Montserrat\" !important;\n}\n.title {\n  font-weight: 700 !important;\n  font-size: 34px !important;\n}\n.subTitle {\n  font-family: \"Montserrat\" !important;\n  font-size: 32px !important;\n  font-weight: 600 !important;\n  line-height: 40px !important;\n  letter-spacing: 0px !important;\n  text-align: left !important;\n  margin-top: 50px !important;\n  color: #3d4a52 !important;\n}\n.checkBox {\n  margin: 20px 0px !important;\n}\n.subTitleCertificates {\n  font-family: \"Montserrat\" !important;\n  font-size: 20px !important;\n  font-weight: 600 !important;\n  line-height: 24.38px !important;\n  letter-spacing: 0px !important;\n  text-align: left !important;\n  margin-top: 20px !important;\n  margin-left: 5px !important;\n}\n.margin5 {\n  margin: 10px 0px !important;\n}\n.fileText {\n  font-family: \"Montserrat\" !important;\n  font-size: 16px !important;\n  font-weight: 400 !important;\n  line-height: 20px !important;\n  letter-spacing: 0px !important;\n  text-align: left !important;\n}\n.blue {\n  color: #3366ff;\n  padding-left: 10px !important;\n}\n.document_upload_logo {\n  flex: 0.1;\n}\n.each_preview_policy {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: auto;\n  padding: 15px 0px !important;\n  border-radius: 10px;\n  font-family: \"Montserrat\" !important;\n}\n.link {\n  max-width: 350px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n  text-decoration: underline;\n}\n.link:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.text_left {\n  text-align: left !important;\n  font-family: \"Montserrat\" !important;\n}\n.fileTextSize {\n  font-size: 18px !important;\n  font-weight: 600 !important;\n  line-height: 24.38px !important;\n}\n.certificateCountStyle{\n  font-size: 18px !important;\n  font-weight: 400 !important;\n  font-family: \"Montserrat\" !important;\n}\n.addMoreBtn {\n  font-family: \"Montserrat\" !important;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  line-height: 24px !important;\n  letter-spacing: 0px !important;\n  text-align: center !important;\n  color: #00ab55 !important;\n  text-transform: none !important;\n}\n.removeBtn {\n  color: #ff5630 !important;\n  font-family: \"Montserrat\" !important;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  line-height: 24px !important;\n  letter-spacing: 0px !important;\n  text-align: center !important;\n  text-transform: capitalize !important;\n}\n.primaryButton {\n  font-family: \"Montserrat\" !important;\n  font-size: 16px !important;\n  font-weight: 700 !important;\n  line-height: 26px !important;\n  letter-spacing: 0px !important;\n  text-align: left !important;\n  width: 172px !important;\n  height: 48px !important;\n  padding: 11px, 55px, 11px, 56px !important;\n  border-radius: 8px !important;\n  border: 1px solid #00ab55 !important ;\n  box-shadow: none !important;\n  color: #00ab55 !important;\n  background-color: none !important;\n  text-transform: none !important;\n  cursor: pointer !important;\n}\n.fileErrorMeesage {\n  font-size: 14px !important;\n  color: #ff5630 !important;\n  font-family: \"Montserrat\" !important;\n}\n.note {\n  font-family: \"Montserrat\" !important;\n  width: 380px !important;\n  text-align: center !important;\n  margin-left: 90px !important;\n  margin-top: 20px !important;\n  font-size: 14px !important;\n}\n.noteGuarantee {\n  font-family: \"Montserrat\" !important;\n  width: 385px !important;\n  text-align: center !important;\n  margin-left: 100px !important;\n  margin-top: 20px !important;\n  font-size: 14px !important;\n}\n.buttonStyle {\n  max-width: fit-content !important;\n  margin-left: auto !important;\n  margin-right: 25px !important;\n}\n.backButton {\n  font-family: \"Montserrat\" !important;\n  font-size: 16px !important;\n  font-weight: 700 !important;\n  line-height: 26px !important;\n  letter-spacing: 0px !important;\n  width: 74px !important;\n  height: 48px !important;\n  padding: 11px, 0px, 11px, 0px !important;\n  color: #00ab55 !important;\n  text-transform: none !important;\n  cursor: pointer !important;\n  margin: 20px 0px 10px 0px !important;\n}\n.subHead {\n  font-family: \"Montserrat\" !important;\n  font-size: 20px !important;\n  font-weight: 600 !important;\n  letter-spacing: 0px !important;\n  text-align: left !important;\n  margin-top: 30px !important;\n  color: #000000 !important;\n  line-height: 24.38px;\n}\n.lastUpdate {\n  color: #212b36 !important;\n  font-size: 14px !important;\n  font-family: \"Montserrat\" !important;\n  font-weight: 400 !important;\n  margin-top: 40px !important;\n  margin-bottom: 30px !important;\n  height: 24px !important;\n  line-height: 24px !important;\n  margin-bottom: 5px;\n}\n.certificateName {\n  font-family: \"Montserrat\" !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  line-height: 30px !important;\n  color: #000000 !important;\n  max-height: 245px !important;\n}\n.fileSize {\n  color: #7c7c7c !important;\n  font-family: \"Montserrat\" !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  line-height: 17.07px !important;\n  text-decoration: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textField": `FPOForm_textField__+uCJ-`,
	"titleHead": `FPOForm_titleHead__3jaJh`,
	"selectBox": `FPOForm_selectBox__qTjyT`,
	"saveBtn": `FPOForm_saveBtn__QUbyq`,
	"title": `FPOForm_title__qLpB8`,
	"subTitle": `FPOForm_subTitle__VtEbv`,
	"checkBox": `FPOForm_checkBox__Fu+iF`,
	"subTitleCertificates": `FPOForm_subTitleCertificates__bV5mK`,
	"margin5": `FPOForm_margin5__ENqdI`,
	"fileText": `FPOForm_fileText__LH1ME`,
	"blue": `FPOForm_blue__DOxKy`,
	"document_upload_logo": `FPOForm_document_upload_logo__-bqpj`,
	"each_preview_policy": `FPOForm_each_preview_policy__fibe2`,
	"link": `FPOForm_link__DOeIe`,
	"text_left": `FPOForm_text_left__oSnaI`,
	"fileTextSize": `FPOForm_fileTextSize__mDwvz`,
	"certificateCountStyle": `FPOForm_certificateCountStyle__NUT-6`,
	"addMoreBtn": `FPOForm_addMoreBtn__sDRP9`,
	"removeBtn": `FPOForm_removeBtn__4upRn`,
	"primaryButton": `FPOForm_primaryButton__WIoM1`,
	"fileErrorMeesage": `FPOForm_fileErrorMeesage__aqtkj`,
	"note": `FPOForm_note__0hjKd`,
	"noteGuarantee": `FPOForm_noteGuarantee__UznLU`,
	"buttonStyle": `FPOForm_buttonStyle__ttKp-`,
	"backButton": `FPOForm_backButton__sn7Ow`,
	"subHead": `FPOForm_subHead__KNWW8`,
	"lastUpdate": `FPOForm_lastUpdate__5mD3e`,
	"certificateName": `FPOForm_certificateName__A-x+s`,
	"fileSize": `FPOForm_fileSize__jTZSn`
};
export default ___CSS_LOADER_EXPORT___;
